import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { APP_ROUTES } from '../constants/routes';
import { SESSION_CONSTANTS } from '../constants';

export const redirectIfLoggedInGuard: CanActivateFn = (route, state) => {
	const router = inject(Router);
	const token = localStorage.getItem(SESSION_CONSTANTS.TOKEN_KEY);
	if (token) {
		return router.parseUrl(APP_ROUTES.HOME);
	}
	return true;
};